import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export const enterTopologyPresetEditMode: GraphCommandFactory =
  (cmdContext) => () => {
    cmdContext.updateState((draft) => {
      draft.layoutSettings.presetEditMode = true;
    });
  };
